/// <reference path="../app.ts" />
namespace Cfnc {

    export interface IStartApplicationService {
        schoolId: string;
        
        clear: () => void;
    }

    export class StartApplicationService implements IStartApplicationService {
        schoolId: string;

        public clear() {
            this.schoolId = null;
        }
    }

    angular.module("app").service("startApplicationService", StartApplicationService);
}